import { useStaticQuery, graphql } from 'gatsby';

const QUERY = graphql`
  query {
    images: allFile(
      filter: { absolutePath: { regex: "//investorsLogos/" } }
      sort: { fields: [name], order: ASC }
    ) {
      edges {
        node {
          extension
          relativePath
          childImageSharp {
            gatsbyImageData(
              formats: [AUTO, WEBP]
              quality: 75
              breakpoints: [300, 500]
              placeholder: BLURRED
              backgroundColor: "transparent"
            )
          }
        }
      }
    }
  }
`;

const GetSponsors = () => {
  const { images } = useStaticQuery(QUERY);
  return images.edges || [];
};

const investors = () => {
  const data = GetSponsors();
  return data;
};

export default investors;
